import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { connect } from 'react-redux';
import { firebaseConnect, dataToJS } from 'react-redux-firebase';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';

import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';
import InfoForm from 'components/InfoForm';

import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';
import { formatPrice } from '../util';

const filesPath = 'files';

class ProductViewPanel extends Component {

	//Need to move state to here
	constructor (props) {
		super(props);
	}

	render () {

        const { files } = this.props;

        let fileId = this.props.product.cover;
        let productFile = files ? files[fileId] : null;

		return (
			<div className="panel product-view">
				<ContentHeader
					title={this.props.product.name}
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">
						<div className="panel-section">
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label for-large-input">Name</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<span>{this.props.product.name}</span>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Description</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<span>{this.props.product.description}</span>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Price</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<span>{formatPrice(this.props.product.price) + ' per student, yearly license'}</span>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Cover Image</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<div>
												<img src={productFile.downloadURL} />
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Request Information</label>
									</div>
									<div className="col-9">
										<InfoForm
											profile={this.props.profile}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<ContentFooter
					onClose={this.props.closeDrawer}
					onCancel={this.props.onCancel}
					cancelLabel="Close"
				/>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

const fbWrappedComponent = firebaseConnect([
    filesPath
])(ProductViewPanel);

export default connect(
    ({ firebase }) => ({
        files: dataToJS(firebase, filesPath)
    }),
	mapDispatchToProps
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/components/ProductViewPanel.js